export default "__VITE_ASSET__Dn5PdH8U__"